import React, { useState, useContext, useEffect, useRef, useCallback } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import {localizeKey, localizeArt} from './../localize.js';
import axiosInstance from './../axiosInstance.js';
import MyUserContext from './../myUserContext.js';
import Collapsible from './Collapsible';
import LinkInput from './LinkInput';
import SelectableTags from './SelectableTags';
import ShareButton from './ShareButton';
import { Link } from 'react-router-dom';
import PlatformRatings from './PlatformRatings';
import ArtPage from './ArtPage';
// import ArtThumbnail from './ArtThumbnail';
import TagBadge, { tagBadgeColor, tagName } from "./TagBadge";
import { saveStateAndScroll, restoreStateAndScroll } from './../utils/stateManager';
import ExpandableImage from './ExpandableImage';
import 'delayed-scroll-restoration-polyfill';
import ArtThumbnail from './ArtThumbnail.js';
import TextUserPair from './TextUserPair.js';
import { formatYear } from './../utils.js'; // Import the global function
import {
  ActionIcon,
  Button,
  Group,
  Image,
  Paper,
  Stack,
  Text,
  TextInput
} from "@mantine/core";

const PersonalArtEvents = ({eventType, userId, repeatedEnter = false}) => {
  const navigate = useNavigate();

  const myUser = useContext(MyUserContext);
  const [finishedInput, setFinishedInput] = useState("");
  const [finishedEvents, setFinishedEvents] = useState(null);

  const [hasAccess, setHasAccess] = useState(true);
  const [followersCount, setFollowersCount] = useState(null);
  const [followeesCount, setFolloweesCount] = useState(null);

  const [artNameTerm, setArtNameTerm] = useState('');

  const { pathUserId } = useParams();
  const effectiveUserId = () => {
    // UserID from props or path param.
    let effectiveUserId = userId;
    if (!effectiveUserId) {
      effectiveUserId = pathUserId;
    }
    return effectiveUserId;
  }

  const alreadySelectedTagIds = new URLSearchParams(window.location.search).getAll('tags');

  const alreadySelectedTagIdsParam = alreadySelectedTagIds.map((t) => { return "tags="+t}).join("&");
  const initEventsFetchUrl = `/artEvents/${effectiveUserId()}/${eventType}?${alreadySelectedTagIdsParam}`;
  const [nextUrl, setNextUrl] = useState(initEventsFetchUrl);
  const [loading, setLoading] = useState(false);
  const observer = useRef();
  const latestRequestIdRef = useRef(0);

  const searchInputRef = useRef(null);
  const [shouldFocus, setShouldFocus] = useState(repeatedEnter);
  const [gridClass, setGridClass] = useState('grid-cols-4');
  const [openGlobalManualTagEventId, setOpenGlobalManualTagEventId] = useState(null);

  const globalManualTags = ["like", "veryGood", "good", "finished", "bad", "inProgress", "todo"];

  const toggleGridCols = () => {
    setGridClass((prevClass) => (prevClass === 'grid-cols-4' ? 'grid-cols-6' : 'grid-cols-4'));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!openGlobalManualTagEventId) {
        return;
      }
      const menuSelector = `[data-global-tag-menu-id="${openGlobalManualTagEventId}"]`;
      if (!event.target.closest(menuSelector)) {
        setOpenGlobalManualTagEventId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openGlobalManualTagEventId]);

  useEffect(() => {
    // alert("repeatedEnter=" + repeatedEnter);
    // Focus the input when the component mounts or when the user navigates back to this page    
    if (searchInputRef.current) {
      if (shouldFocus) {
        searchInputRef.current.focus();
      } else {
        searchInputRef.current.blur();
      }
    }
  });

  useEffect(() => {
    // Enable scroll restoration
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    setFinishedEvents(null);
    setCurUser(null);
    setNextUrl(`/artEvents/${effectiveUserId()}/${eventType}?${alreadySelectedTagIdsParam}`);
    setFetching(false);
    setHasAccess(true);
    setFollowersCount(null);
    setFolloweesCount(null);
  }, [pathUserId, eventType]);

  // TODO: use this to save state and scroll position when navigating away
  // useEffect(() => {
  //   // Restore state and scroll when navigating back
  //   restoreStateAndScroll((restoredState) => {
  //     if (restoredState) {
  //       setFinishedEvents(restoredState.finishedEvents || null);
  //       setArtNameTerm(restoredState.artNameTerm || '');
  //       setNextUrl(restoredState.nextUrl || initEventsFetchUrl);
  //     }
  //   });
  // }, []);

  // const handleNavigation = () => {
  //   // Save state and scroll before navigating away
  //   saveStateAndScroll(window.location.pathname, {
  //     finishedEvents,
  //     artNameTerm,
  //     nextUrl,
  //   });
  //   navigate('/some-other-path'); // Example navigation
  // };

  const [fetching, setFetching] = useState(false);

  const [curUser, setCurUser] = useState(null); // some other user
  const fetchCurUser = () => {
    axiosInstance
    .get(`/users/${effectiveUserId()}`)
    .then((response) => {
      setCurUser(response.data);
    })
    .catch((error) => {
      console.error(error);      
    });
  }

  const fetchFollowCounts = () => {
    const targetUserId = effectiveUserId();
    if (!targetUserId) {
      setFollowersCount(null);
      setFolloweesCount(null);
      return;
    }

    Promise.all([
      axiosInstance.get(`/getUsers?onlyMyFollowers=true&forUserId=${targetUserId}`),
      axiosInstance.get(`/getUsers?onlyMyFollowees=true&forUserId=${targetUserId}`)
    ])
    .then(([followersResponse, followeesResponse]) => {
      setFollowersCount(followersResponse.data.length);
      setFolloweesCount(followeesResponse.data.length);
    })
    .catch((error) => {
      console.error(error);
    });
  };

  const [relevantTags, setRelevantTags] = useState(null);
  const fetchRelevantTags = (alreadySetTagIds=[]) => {
    const tagParams = alreadySetTagIds.map((n) => { return "alreadySetTags="+n; }).join("&");
    axiosInstance
    .get(`/relevant/tags?userId=${effectiveUserId()}&type=${eventType}&${tagParams}`)
    .then((response) => {
      setRelevantTags(response.data);
    })
    .catch((error) => {
      console.error(error);
    })
  }

  const [showTags, setShowTags] = useState(false);

  const [unfinishedRecomsCount, setUnfinishedRecomsCount] = useState(null);
  const fetchUnfinishedRecomsCount = () => {
    axiosInstance
    .get('/recommendations/unfinished/count')
    .then((response) => {
      setUnfinishedRecomsCount(response.data.unfinished);
    })
    .catch((error) => {
      // console.error(error.message);
    })
  }

  const [selectedItem, setSelectedItem] = useState(null);

  const modalRef = useRef(null);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);

  const isTouchDevice = () => 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  const preventDefault = (e) => {
    e.preventDefault();
  };

  const handleTouchStart = (e) => {
    setIsDragging(true);
    const rect = modalRef.current.getBoundingClientRect();
    setDragOffset({
      x: e.touches[0].clientX - rect.left,
      y: e.touches[0].clientY - rect.top,
    });
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const modal = modalRef.current;
    const deltaX = e.touches[0].clientX - dragOffset.x;
    const deltaY = e.touches[0].clientY - dragOffset.y;
    if (deltaX < 0) {
      return; // Prevent dragging to the left
    }

    // Enable drag only if deltaX > deltaY
    if (Math.abs(deltaX) > Math.abs(deltaY)) {
      // Disable scrolling.
      modal.style.overflow = 'hidden';
      modal.addEventListener('touchmove', preventDefault, { passive: false });

      modal.style.transform = `translate(${deltaX}px, 0)`;

      // Reduce width and height proportionally, scale more slowly
      const scale = 1 - Math.min(deltaX / (window.innerWidth * 2), 0.1); // Limit reduction to 10%
      modal.style.transform += ` scale(${scale})`;

      // Enable vertical drag after horizontal drag
      if (Math.abs(deltaX) > 70) {
        modal.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(${scale})`;
      }
    }
  };

  const handleTouchEnd = () => {
    setIsDragging(false);

    // Enable scrolling again.
    modalRef.current.style.overflow = 'auto';
    modalRef.current.removeEventListener('touchmove', preventDefault);

    const rect = modalRef.current.getBoundingClientRect();
    const modalWidth = rect.width;

    // Close modal if dragged to the right by at least 20% of its width
    if (rect.left - dragOffset.x > modalWidth / 5) {
      setSelectedItem(null);
    } else {
      // Reset position if not dragged far enough
      modalRef.current.style.transform = "translate(0, 0)";
    }
  };

  const fetchFinishedEvents = useCallback((nextUrl, fromScratch = false) => {
    if (!nextUrl || (loading && !fromScratch)) {
      return;
    }
    const requestId = latestRequestIdRef.current + 1;
    latestRequestIdRef.current = requestId;
    setLoading(true);
    axiosInstance
    .get(nextUrl)
    .then((response) => {
      if (latestRequestIdRef.current !== requestId) {
        return;
      }
      if (finishedEvents === null || fromScratch) {
        setFinishedEvents(response.data.data);
      } else {
        setFinishedEvents(prevObjects => [...prevObjects, ...response.data.data]);
      }
      setNextUrl(response.data.nextPageUrl);
    })
    .catch((error) => {
      if (latestRequestIdRef.current !== requestId) {
        return;
      }
      if (error.response) {
        // Server responded with a status other than 200 range
        if (error.response.status === 403 || error.response.status === 401) {
          // Handle 403 Forbidden
          setHasAccess(false);
          console.log("Setting has access to false");
        } else {
          console.error('Error: ', error.response.data);
        }
      } else {
        console.error(error);  
      }
    })
    .finally(() => {
      if (latestRequestIdRef.current === requestId) {
        setLoading(false);
      }
    });
  }, [finishedEvents, loading]);

  const handleFinishedInputChange = (event) => {
    setFinishedInput(event.target.value);
  };
  const handleFinished = () => {
    axiosInstance
    .post(`/artEvents`, { wikiArticleLink: finishedInput, type: eventType })
    .then((response) => {
      if (finishedEvents === null) {
        setFinishedEvents(response.data);
      } else {
        setFinishedEvents(prevObjects => [response.data, ...prevObjects]);  
      }
      setFinishedInput("");
    })
    .catch((error) => {
      console.error(error);
    });
  };

  const lastObjectRef = useCallback(node => {
    if (loading) return;

    if (observer.current) {
      observer.current.disconnect();
    }
    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        fetchFinishedEvents(nextUrl);
      }
    });
    if (node) {
      observer.current.observe(node);
    }
  }, [loading, nextUrl, fetchFinishedEvents]);

  const curUserIsMe = () => {
    return (myUser && effectiveUserId() === myUser.myUserInfo.myUserId);
  }

  const isMobileDeviceExceptAndroid = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /iphone|ipad|ipod|windows phone|blackberry/i.test(userAgent);
  };

  const isFirefox = () => {
    return navigator.userAgent.toLowerCase().includes('firefox');
  };

  const isMobile = () => window.innerWidth <= 768;

  const handleItemClick = (item) => {
    if (isMobile()) {
      setSelectedItem(item); // Open modal on mobile
    } else {
      navigate(`/arts/${item.art.id}`); // Navigate on desktop
    }
  };

  const getGlobalManualTag = (eventTags) => {
    return eventTags?.find(tag => tag.type === 3)?.name || "like";
  };

  const handleGlobalManualTagSelect = (item, selectedTag) => {
    if (!item?.event?.id) {
      return;
    }
    const existingTags = item.event.eventTags?.map((tag) => tag.name) || [];
    const updatedTags = [
      selectedTag,
      ...existingTags.filter((tag) => !globalManualTags.includes(tag)),
    ];

    axiosInstance
      .post(`/artEvents/tag/${item.event.id}/tag`, { tags: updatedTags })
      .then((response) => {
        const updatedEvent = response.data.event;
        setFinishedEvents((prevEvents) => {
          if (!prevEvents) {
            return prevEvents;
          }
          return prevEvents.map((prevItem) =>
            prevItem.event.id === updatedEvent.id
              ? { ...prevItem, event: updatedEvent }
              : prevItem
          );
        });
        setOpenGlobalManualTagEventId(null);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const initialFetchDoneRef = useRef(false);
  useEffect(() => {
    if (!hasAccess || finishedEvents !== null || curUser !== null || fetching) {
      return;
    }
    if (initialFetchDoneRef.current) {
      return;
    }
    initialFetchDoneRef.current = true;
    setFetching(true);
    fetchFinishedEvents(nextUrl);
    fetchUnfinishedRecomsCount();
    fetchCurUser();
    fetchFollowCounts();
    fetchRelevantTags(alreadySelectedTagIds);
  }, [
    hasAccess,
    finishedEvents,
    curUser,
    fetching,
    fetchFinishedEvents,
    nextUrl,
    alreadySelectedTagIds,
  ]);

  if (hasAccess && (finishedEvents === null || curUser === null)) {
    return (
      <div></div>
    )
  }

  const language = myUser ? myUser.myUserSettings.lang : 'ru';
  const followersLabel = language === "ru" ? "Подписчики" : "Followers";
  const followeesLabel = language === "ru" ? "Подписки" : "Followings";
  const followersText = followersCount !== null ? `${followersLabel} (${followersCount})` : followersLabel;
  const followeesText = followeesCount !== null ? `${followeesLabel} (${followeesCount})` : followeesLabel;

  let buttonTextLocalizeKey = "addFinished";
  if (eventType === "like") {
    buttonTextLocalizeKey = "like";
  } else if (eventType === "todo") {
    buttonTextLocalizeKey = "addTodo";
  }

  // console.log("finishedEvents[0].event.chatId: " + finishedEvents[0].event.chatId);

  // Links to other types of events: start
  // TODO: move it to a separate user page component.
  const likesLink = `/users/${effectiveUserId()}/likes`;
  const classLikes = (eventType === "like" ? "underline" : "");

  const todosLink = `/users/${effectiveUserId()}/todos`;
  const classTodos = (eventType === "todo" ? "underline" : "");

  const finishedLink = `/users/${effectiveUserId()}/finished`;
  const classFinished = (eventType === "finished" ? "underline" : "");

  // Links to other types of events: end

  return (
    <div className="container mx-auto px-1 md:px-2 w-full lg:w-3/4">
      {/* <div className="container mx-auto">
        {
          myUser && effectiveUserId() !== myUser.myUserInfo.myUserId &&
            <TextUserPair user={curUser} userId={effectiveUserId()} hideRecomInput={true}/>
        }        
      </div> */}
      {
      (hasAccess === false) ?
        <div className="flex justify-center text-center">
          {language === "ru" ? "Приватный аккаунт, подпишитесь на пользователя и дождитесь подтверждения" : "Account is private, subscribe to user and wait for approval"}
        </div> 
        :
          <>
            {
            (eventType === 'like') &&
            <div>
              {/*<div className="flex justify-between items-center mt-2 mb-1 px-2">
                <div className="flex justify-center items-center space-x-2">
                  <Link to={"/logbookHistory?userId="+effectiveUserId()}>
                      <div className="container mx-auto flex justify-center items-center">
                      <div className="flex group-hover:hidden">
                        <img className="mt-0.5 max-w-9 max-h-9" src="/calendar_icon_2.png" alt="Calendar" />
                      </div>
                    </div>
                  </Link>
                  {
                  (myUser && effectiveUserId() === myUser.myUserInfo.myUserId) &&
                    <Link to="/settings">
                      <img
                        src="/settings_icon.png"
                        alt={language === "ru" ? "Настройки" : "Settings"}
                        className="w-9 h-9 cursor-pointer"
                        // onClick={() => navigate('/settings')} // Example navigation to settings
                      />
                    </Link>
                  }
                </div>
              </div> */}
              <div>
                <Paper radius="md" p="sm" bg="transparent">
                  <Stack gap="sm">
                    <Group gap="sm" align="center" wrap="wrap">
                      <Group gap="sm" align="center" wrap="wrap">
                        <TextUserPair user={curUser} hideRecomInput={true} />
                        {(myUser && effectiveUserId() === myUser.myUserInfo.myUserId) && (
                          <ActionIcon
                            component={Link}
                            to="/settings"
                            variant="light"
                            size="lg"
                            radius="md"
                            aria-label={language === "ru" ? "Настройки" : "Settings"}
                          >
                            <Image src="/settings_icon.png" alt={language === "ru" ? "Настройки" : "Settings"} w={18} h={18} fit="contain" />
                          </ActionIcon>
                        )}
                      </Group>
                    </Group>

                    <Group justify="space-between" align="center" wrap="wrap" w="100%">
                      <Group gap="sm" wrap="wrap">
                        <Button
                          component={Link}
                          to={`/users?onlyMyFollowers=true&forUserId=${effectiveUserId()}`}
                          variant="light"
                          size="sm"
                          radius="md"
                        >
                          {followersText}
                        </Button>
                        <Button
                          component={Link}
                          to={`/users?onlyMyFollowees=true&forUserId=${effectiveUserId()}`}
                          variant="light"
                          size="sm"
                          radius="md"
                        >
                          {followeesText}
                        </Button>
                      </Group>
                      <Button
                        component={Link}
                        to={`/logbookHistory?userId=${effectiveUserId()}`}
                        variant="light"
                        size="sm"
                        radius="md"
                        leftSection={<Image src="/calendar_icon_2.png" alt="Calendar" w={14} h={14} fit="contain" />}
                      >
                        {language === "ru" ? "Журнал" : "Logbook"}
                      </Button>
                    </Group>

                    {(myUser && curUser.id !== myUser.myUserInfo.myUserId && curUser.matchScore) && (
                      <Text size="sm" c="dimmed" lh="sm">
                        {Math.floor(curUser.matchScore * 100) + "%" + " "}
                        {language === "ru" ? "совпадение вкусов" : "match of tastes"}
                        <br />
                        {language === "ru"
                          ? `(на основе ${curUser.matchArtsCount} произведений)`
                          : "(based on ${curUser.matchArtsCount} arts)"}
                      </Text>
                    )}
                  </Stack>
                </Paper>
              </div>
            </div>
            }

            {
            (finishedEvents && finishedEvents.length == 0) && artNameTerm === '' && !loading &&
              <div className="mt-5 justify-center text-center">
                {
                language === "ru"
                ?                  
                  (myUser && effectiveUserId() === myUser.myUserInfo.myUserId)
                  ?
                    eventType.includes('recommendation')
                    ?
                      <>
                        
                      </>
                    :
                      <>
                        Вы пока не добавили ни одного произведения в свою библиотеку.
                        Перейдите в поиск <img className="inline max-w-6 max-h-6" src="/add_icon.png" /> и добавьте произведения.
                      </>
                  :
                    <>
                      Пользователь пока не добавил ни одного произведения в свою библиотеку.
                    </>
                :
                  (myUser && effectiveUserId() === myUser.myUserInfo.myUserId)
                  ?                    
                    eventType.includes('recommendation')
                    ?
                      <>
                        No personal recommendations yet.
                      </>
                    :
                      <>
                        You have not added any arts yet to your library.
                        Go to search <img className="inline max-w-6 max-h-6" src="/add_icon.png" /> and add arts.
                      </>                    
                  :
                    <>
                      The user has not added any arts yet to their library.
                    </>
                }
              </div>
            }

            {
            (finishedEvents && finishedEvents.length > 0 || artNameTerm.length > 0 || eventType.includes('recommendation')) &&
            <div className={"rounded-md border-dotted left-0 w-full z-50 justify-center" + (myUser ? " bottom-20" : " bottom-0")} style={{ borderColor: "var(--mantine-color-default-border)" }}>

              <div className="flex justify-center items-center space-x-4">
                {
                myUser && effectiveUserId() === myUser.myUserInfo.myUserId &&
                  (
                    eventType.includes('recommendation')
                    &&
                      <div>
                        <div className="flex justify-center items-center text-center space-x-4">
                          <Link to={`/users/${effectiveUserId()}/recommendationsIncoming`}>
                            <Button
                              variant="light"
                              size="sm"
                              radius="md"
                              className={eventType === "recommendationIncoming" ? "underline" : ""}
                            >
                              {language === "ru" ? "Мне" : "To me"} 
                            </Button>
                          </Link>
                          <Link to={`/users/${effectiveUserId()}/recommendationsOutgoing`}> 
                            <Button
                              variant="light"
                              size="sm"
                              radius="md"
                              className={eventType === "recommendationOutgoing" ? "underline" : ""}
                            >
                              {language === "ru" ? "От меня" : "From me"} 
                            </Button>
                          </Link>  
                        </div>
                      </div>
                  )                
                }
              </div>

              <div className="flex justify-center items-center mt-6 mb-2">
                <div className="flex font-[sans-serif]">
                  <TextInput
                    ref={searchInputRef}
                    type="search"
                    className="w-64"
                    value={artNameTerm}
                    onChange={(event) => {
                      const nextTerm = event.currentTarget.value;
                      const eventsFetchUrl = `/artEvents/${effectiveUserId()}/${eventType}?${window.location.search}&artNameTerm=${nextTerm}`;
                      fetchFinishedEvents(eventsFetchUrl, true);

                      setArtNameTerm(nextTerm); // to intercept in tags selection
                      setShouldFocus(true);
                    }}
                    placeholder={language === "ru" ? ( (!myUser || effectiveUserId() !== myUser.myUserInfo.myUserId) ? "Поиск в библиотеке пользователя" : "Поиск в моей библиотеке") : ( (!myUser || effectiveUserId() !== myUser.myUserInfo.myUserId) ? "Search in user's library" : "Search in my library")}
                    leftSection={
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192.904 192.904" width="16px"
                        className="rotate-120" style={{ fill: "var(--mantine-color-dimmed)" }}>
                        <path
                          d="m190.707 180.101-47.078-47.077c11.702-14.072 18.752-32.142 18.752-51.831C162.381 36.423 125.959 0 81.191 0 36.422 0 0 36.423 0 81.193c0 44.767 36.422 81.187 81.191 81.187 19.688 0 37.759-7.049 51.831-18.751l47.079 47.078a7.474 7.474 0 0 0 5.303 2.197 7.498 7.498 0 0 0 5.303-12.803zM15 81.193C15 44.694 44.693 15 81.191 15c36.497 0 66.189 29.694 66.189 66.193 0 36.496-29.692 66.187-66.189 66.187C44.693 147.38 15 117.689 15 81.193z">
                        </path>
                      </svg>
                    }
                    rightSection={
                      (isMobileDeviceExceptAndroid() || isFirefox()) && artNameTerm ? (
                        <ActionIcon
                          variant="subtle"
                          color="gray"
                          size="sm"
                          onClick={() => {
                            const eventsFetchUrl = `/artEvents/${effectiveUserId()}/${eventType}?${window.location.search}&artNameTerm=`;
                            fetchFinishedEvents(eventsFetchUrl, true);

                            setArtNameTerm('');
                            setShouldFocus(true);
                            if (searchInputRef.current) {
                              searchInputRef.current.focus();
                            }
                          }}
                          aria-label={language === "ru" ? "Очистить поиск" : "Clear search"}
                        >
                          &times;
                        </ActionIcon>
                      ) : null
                    }
                    styles={{
                      input: {
                        backgroundColor: "var(--mantine-color-default)",
                        color: "var(--mantine-color-text)",
                        border: "none"
                      },
                      section: { color: "var(--mantine-color-dimmed)" }
                    }}
                    radius="xl"
                  />
                </div>
                {/* {
                (finishedEvents && finishedEvents.length > 5) &&
                  <div className="ml-2 text-4xl leading-none transform translate-y-[-2px] hover:cursor-pointer hover:text-gray-400" onClick={toggleGridCols}>
                    ⊞
                  </div>
                } */}
                {/*
                <div className="text-3xl">
                  {
                    eventType === "like" &&
                    <ShareButton
                      url={
                        window.location.href
                      }
                      text={
                        ""
                      }
                      overrideButtonText="🔗"
                    />
                  }
                </div>
                */}
              </div>
              {
              // showTags &&
              <div className="mb-2">
                <SelectableTags language={language} relevantTags={relevantTags !== null ? relevantTags : []} alreadySelectedTags={ relevantTags ? relevantTags.filter((t) => alreadySelectedTagIds.includes(t.tag.id)) : []} onSelectionChange={(tags) => {
                  const tagParams = tags.map((t) => { return "tags="+t.tag.id; }).join("&");

                  const url = 'https://wowcontent.lol';
                  // const url = 'http://localhost:8080'
                  let urlEventType = "likes";
                  if (eventType === "recommendationIncoming") {
                    urlEventType = "recommendationsIncoming";
                  } else if (eventType === "recommendationOutgoing") {
                    urlEventType = "recommendationsOutgoing";
                  }
                  window.history.pushState({}, '', `${url}/users/${curUser.id}/${urlEventType}${ tagParams ? "?"+tagParams : "" }`);

                  const eventsFetchUrl = `/artEvents/${effectiveUserId()}/${eventType}?${tagParams}&artNameTerm=${artNameTerm}`;
                  fetchFinishedEvents(eventsFetchUrl, true);

                  const tagIds = tags.map((t) => { return t.tag.id; });
                  fetchRelevantTags(tagIds);
                }} />
              </div>
              }
            </div>
            }
            {/* Grid */}
            <div className={`grid grid-cols-4 md:grid-cols-6 gap-x-2 gap-y-4 mt-2`}>
              {finishedEvents.map((item, index) => (
                <div
                  key={index}
                  ref={index === finishedEvents.length - 1 ? lastObjectRef : null} // Restore lastObjectRef
                  className="h-full flex flex-col"
                >
                  <Stack gap={0} className="h-full">
                    <div className="relative">
                      <Link to={"/arts/"+item.art.id} className="block">
                        <ArtThumbnail art={item.art} displayCheckmark={eventType !== "like"} displayTag={false} />
                      </Link>
                    </div>
                    {(
                      <div className="mt-auto flex flex-col">
                        <div className="flex justify-center mt-1 mb-1 h-[32px]" data-global-tag-menu-id={item.event.id}>
                          {eventType.includes('like') && (
                            <>
                              <TagBadge
                                component="button"
                                type="button"
                                className="cursor-pointer w-full justify-center"
                                radius="md"
                                size="md"
                                color={tagBadgeColor(getGlobalManualTag(item.event.eventTags), 3)}
                                variant="filled"
                                rightSection={curUserIsMe() ? <span className="text-[10px] opacity-70">▼</span> : undefined}
                                onClick={() => {
                                  if (curUserIsMe()) {
                                    setOpenGlobalManualTagEventId(
                                      openGlobalManualTagEventId === item.event.id ? null : item.event.id
                                    );
                                  }
                                }}
                              >
                                {tagName(getGlobalManualTag(item.event.eventTags), language)}
                              </TagBadge>
                              {curUserIsMe() && openGlobalManualTagEventId === item.event.id && (
                                <div className="relative">
                                  <div className="absolute left-1/2 -translate-x-1/2 top-full mt-1 z-40">
                                    <Paper p="xs" radius="md" shadow="md" withBorder className="flex flex-col gap-1">
                                      {globalManualTags.map((tag) => {
                                        return (
                                          <TagBadge
                                            key={tag}
                                            component="button"
                                            type="button"
                                            radius="md"
                                            size="md"
                                            className="cursor-pointer w-full justify-center"
                                            color={tagBadgeColor(tag, 3)}
                                            variant="filled"
                                            onClick={() => handleGlobalManualTagSelect(item, tag)}
                                          >
                                            {tagName(tag, language)}
                                          </TagBadge>
                                        );
                                      })}
                                    </Paper>
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                          {eventType.includes('recommendation') && (
                            <div className="flex items-center justify-center -space-x-2">
                              {(item.event.eventTags || [])
                                .filter((tag) => tag.imgUrl)
                                .slice(0, 5)
                                .map((tag, avatarIndex) => (
                                  <img
                                    key={`${tag.imgUrl}-${avatarIndex}`}
                                    src={tag.imgUrl}
                                    alt={tag.name || "avatar"}
                                    className="w-6 h-6 rounded-full"
                                    style={{ border: "1px solid var(--mantine-color-default-border)", backgroundColor: "var(--mantine-color-default)" }}
                                  />
                                ))}
                            </div>
                          )}
                        </div>
                        <Paper px="xs" pt="xs" pb={4} className="h-[80px] flex flex-col" shadow="xs" radius={0}>
                          <div className="flex flex-col gap-0.5">
                            <Text
                              ta="center"
                              fw={600}
                              size="xs"
                              lh="sm"
                              lineClamp={1}
                            >
                              {( (language === "en" || !item.art.ruName) ? item.art.name : item.art.ruName) + formatYear(item.art.year, language)}
                            </Text>
                            <div className="flex justify-center text-center items-center">
                              <PlatformRatings art={item.art} />
                            </div>
                          </div>
                          <div className="flex items-center justify-center gap-2 mt-2">
                            <Link to={`/artEvents/${item.event.id}`} className="flex items-center">
                              <img
                                src="/chat_icon.png"
                                alt={language === "ru" ? "К моему обсуждению" : "Go to my discussion"}
                                className="inline-block w-5 h-5 opacity-80"
                              />
                              {item.chat?.messageCount > 0 && (
                                <Text component="span" className="ml-1" size="xs" c="dimmed">
                                  {item.chat.messageCount}
                                </Text>
                              )}
                            </Link>
                          </div>
                        </Paper>
                      </div>
                    )}
                  </Stack>
                </div>
              ))}
            </div>
            {/* <button onClick={handleNavigation}>Navigate</button> */}
            
          </>
      }
      
    </div>
  );
}

export default PersonalArtEvents;
